import { toast } from "react-toastify";
import { isEmpty } from "../utils/Util";
import jwt_decode from "jwt-decode";
import axios, { AxiosRequestConfig } from "axios";
import { setCredentials } from "../features/auth/authSlice";
import { datadogLogs } from "@datadog/browser-logs";

export async function EverestApi(query, queryBody) {
  const url = `${process.env.REACT_APP_EVEREST_URL}api/Query`;

  const username = `${process.env.REACT_APP_EVEREST_USERNAME}`;
  const password = `${process.env.REACT_APP_EVEREST_PASSWORD}`;
  const credentials = btoa(`${username}:${password}`);

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    Accept: "application/json",
    Authorization: `Basic ${credentials}`
  };
  try {
    const response = await axios.post(url, { query, queryBody }, { headers });
    return response.data;
  } catch (error) {
    datadogLogs.logger.error('API Error', {
      message: error?.message,
      httpStatus: error?.response?.status,
    });
    alert(error);
  }
}

export async function TargetPayApi(
  query,
  data = null,
  method = "post",
  resource = "PerseusPay",
  returnError = false,
  showError = true
) {
  let url = `${process.env.REACT_APP_BASE_URL}${resource}/${query}`;
  let apiKey = sessionStorage.getItem("nonce");
  let header;
  if (!isEmpty(apiKey)) {
    header = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-API-KEY": apiKey,
      AppAgent: "TPFrontEnd"
    };
  } else {
    header = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      AppAgent: "TPFrontEnd"
    };
  }

  // Normalize method to lowercase for comparison
  const normalizedMethod = method.toLowerCase();

  // Methods that support request body
  const methodsWithBody = ["post", "put", "patch"];

  const config: AxiosRequestConfig = {
    headers: header,
    url: url,
    method: normalizedMethod
  };

  // Only add data/params if data exists
  if (data) {
    if (methodsWithBody.includes(normalizedMethod)) {
      config.data = data; // Body for POST, PUT, PATCH
    } else {
      config.params = data; // Query params for GET, DELETE
    }
  }

  try {
    let response = await axios(config);
    return response.data;
  } catch (error) {
    datadogLogs.logger.error('API Error', {
      message: error?.message,
      httpStatus: error?.response?.status,
    });
    if (error.message.toLowerCase().includes("401")) {
      const refresh_token = localStorage.getItem("refresh_token");
      const success: boolean = await GetRefreshToken(refresh_token);
      if (success) {
        // Call the function again which gave 401-Unauthorized exception with new access token
        config.headers.Authorization = `Bearer ${localStorage.getItem(
          "access_token"
        )}`;
        let response = await axios(config);
        return response.data;
      } else {
        // return to Login
        window.location.href = "/login";
      }
    } else {
      let e = error.message;
      if (e.toLowerCase().includes("network error")) e = "Network Error...";
      toast.dismiss();
      if (
        !query.toLowerCase().includes("getvaultedcardid") &&
        !query.toLowerCase().includes("storeterminals")
      ) {
        if (showError) {
          toast.error("Error: " + e, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: false,
            closeOnClick: true
          });
        }
      }
    }
    if (returnError) return error;
  }
}

export async function DealerProfile(key: any) {
  let token = localStorage.getItem("access_token");
  if (isEmpty(token)) return null;
  let JWTDeCode: any = jwt_decode(token);
  return JSON.parse(JWTDeCode.profile)[key];
}

export async function GetCompanyDealerId() {
  var _groupDealerId = localStorage.getItem("group_dealerId");
  if (_groupDealerId && Number(_groupDealerId) > 0) return _groupDealerId;

  return DealerProfile("companyDealerId");
}

export function JWTDecode(token: any, key: any) {
  if (isEmpty(token)) return null;
  let JWTDeCode: any = jwt_decode(token);
  let val = JWTDeCode[key];
  if (isEmpty(val)) return null;
  return val;
}

export function ValidatePhoneNumber(phoneNumber: string) {
  phoneNumber = phoneNumber.replace("+1", "");
  let phone = phoneNumber.replace(/[^0-9a-z]/gi, "");
  const regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return regex.test(phone);
}

export function isValidUSPhoneNo(phoneNo: string) {
  // Regular expression to match the format "+1 (999) 999 9999"
  const phoneRegex = /^\+\d{1}\s\(\d{3}\)\s\d{3}\s\d{4}$/;
  return phoneRegex.test(phoneNo);
}

export function formatUSPhoneNo(phoneNo: string) {
  // Remove all non-digit characters from the phone number
  const cleanedPhoneNo = phoneNo.replace(/\D/g, "");

  // Format the phone number into the desired format
  const formattedPhoneNo = `+1 (${cleanedPhoneNo.substring(
    0,
    3
  )}) ${cleanedPhoneNo.substring(3, 6)} ${cleanedPhoneNo.substring(6)}`;
  return formattedPhoneNo;
}

export function ValidateEmail(email) {
  let validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
  return email.match(validRegex);
}

export function GetDealerPlatformFeeOption() {
  const storedValue = localStorage.getItem("platformFee_date_enabled");
  const isPlatformFeeDateEnabled =
    storedValue !== "null" && storedValue !== "" && storedValue !== null;

  return isPlatformFeeDateEnabled;
}
export function GetDealerHostUrl() {
  const hostUrl = localStorage.getItem("hostUrl");
  return hostUrl;
}

export function GetDealerPlatformFeeFlag() {
  const storedValue = localStorage.getItem("platformFee_flag_enabled");
  const isPlatformFeeFlagEnabled = storedValue !== "false";

  return isPlatformFeeFlagEnabled;
}

export async function GetDealerSettings(dealerId: number) {
  let _dealerId = await DealerProfile("dealerId");

  localStorage.setItem("platformFee_flag_enabled", "false");
  localStorage.setItem("surchargeFee_flag_enabled", "false");
  localStorage.setItem("hasSurchargeEverEnabled", "false");
  localStorage.setItem("platformFee_date_enabled", null);
  localStorage.setItem("storeReference", "");

  if (dealerId > 0) {
    _dealerId = dealerId;
  }
  const res = await TargetPayApi(
    `GetDealerSettings?dealerId=${_dealerId}`,
    null,
    "get"
  );

  if (!isEmpty(res)) {
    localStorage.setItem("platformFee_flag_enabled", res.isPlatformFeeEnabled);
    localStorage.setItem(
      "hasSurchargeEverEnabled",
      res.hasSurchargeEverEnabled
    );
    localStorage.setItem("surchargeFee_flag_enabled", res.isSurchargeEnabled);
    localStorage.setItem(
      "platformFee_date_enabled",
      res.platformFeeDateEnabled
    );
    localStorage.setItem("hostUrl", res.hostUrl);
    localStorage.setItem("storeReference", res.storeReference);
    localStorage.setItem("merchantId", res.merchantId);
    localStorage.setItem("accountHolderReference", res.accountHolderReference);
    localStorage.setItem(
      "isACHPaymentEnabled",
      res.isACHPaymentEnabled || false
    );
    localStorage.setItem("accountHolderId", res.accountHolderId);
    localStorage.setItem("countryCode", res.countryCode);
  }
}

// Get Industry Codes
export async function GetIndustryCodes(countryCode: string) {
  const response = await TargetPayApi(
    `GetIndustryCodes?countryCode=${countryCode}`,
    null,
    "get"
  );
  return response;
}

// Get Payment Methods
export async function GetPaymentMethods(countryCode: string) {
  const response = await TargetPayApi(
    `GetPaymentMethods?countryCode=${countryCode}`,
    null,
    "get"
  );
  return response;
}

// Get Dealer Payment Methods
export async function GetDealerPaymentMethods(
  dealerId: number,
  storeId: string,
  countryCode: string
) {
  const response = await TargetPayApi(
    `GetDealerPaymentMethods?dealerId=${dealerId}&storeId=${storeId}&countryCode=${countryCode}`,
    null,
    "get"
  );
  return response;
}

export async function GetRefreshToken(refresh_token: any): Promise<boolean> {
  let url = `${process.env.REACT_APP_BASE_URL}Account/refreshToken`;
  try {
    const response = await axios.post(url, {
      RefreshToken: refresh_token
    });

    if (response.data != null) {
      setCredentials({
        access_token: response.data.access_token,
        expires_in: response.data.expires_in,
        refresh_token: response.data.refresh_token,
        token_type: response.data.token_type,
        scope: response.data.scope
      });
      localStorage.setItem("access_token", response.data.access_token);
      localStorage.setItem("refresh_token", response.data.refresh_token);
      localStorage.setItem("onboardDealer_token", "");

      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function GetDealerPaymentGateway(dealerId: number) {
  if (isEmpty(dealerId)) {
    return false;
  }

  const res = await TargetPayApi(
    `GetDealerPaymentGateway?dealerId=${dealerId}`,
    null,
    "get"
  );

  if (!isEmpty(res)) {
    localStorage.setItem("payment_gateway", res);
    return res;
  }
}

export async function GetDealerOnboardedLocationGroups(
  dmsDealerId: number,
  companyDealerId: number
) {
  if (isEmpty(dmsDealerId) || isEmpty(companyDealerId)) {
    return null;
  }

  var userName = JWTDecode(localStorage.getItem("access_token"), "name");
  let obj: any = new Object();
  obj.companyDealerId = companyDealerId;
  obj.dmsDealerId = dmsDealerId;
  obj.userName = userName ? userName : "";

  const res = await TargetPayApi(
    `GetOnboardedLocationGroups`,
    JSON.stringify(obj),
    "post",
    "Dealer"
  );

  if (!isEmpty(res)) {
    return res;
  }
}

export async function saveDealerLoggedinGroup(
  locationGroupId: number,
  userName: string
) {
  let dmsDealerId = await DealerProfile("everestDmsDealerId");
  if (isEmpty(dmsDealerId) || isEmpty(locationGroupId)) {
    return null;
  }
  let obj: any = new Object();
  obj.locationGroupId = locationGroupId;
  obj.dmsDealerId = dmsDealerId;
  obj.userName = userName;

  const res = await TargetPayApi(
    `RememberUserLastLocationGroup`,
    JSON.stringify(obj),
    "post",
    "Dealer"
  );

  if (!isEmpty(res)) return res;
}
